import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import {
    Link,
} from "react-router-dom";
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import ReportBilling from '../../../components/report/SiteReportBilling.js';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import Calendar from '../../../components/calendar/Calendar.js';

function ReportBill(props) {
    const [billdata, setBilldata] = useState({
        permit: [],
        table_header: '-'
    });
    const [reportdata, setReportdata] = useState({});
    const [popup_report, setPopup_report] = useState(false);
    const [reportsite, setReportsite] = useState('-');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        return () => {
            setBilldata({
                permit: [],
                table_header: '-'
            })
        };
    }, []);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'year') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'year')
    }

    async function api_get_permit_list() {
        setmodal_load({ enable: true, message: "Loading monthly bill." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportsite', reportsite)
        formData.append('reportyear', dayjs(reportdate_dt).format('YYYY'))

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/report/billing/getpermit", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setBilldata({
                        ...billdata,
                        permit: response.data.permit,
                        table_header: response.data.table_header
                    })
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_query_report(reportsite, reportmonth) {
        setReportdata({})

        setmodal_load({ enable: true, message: "Generating billing report." })
        await sleep(500)

        const formData = new FormData();
        formData.append('post_url', "/proxy/center/api/historical/report/billing")
        formData.append('token', props.permitdata.token)
        formData.append('reportsite', reportsite)
        formData.append('reporttype', "billing")
        formData.append('reportmonth', reportmonth)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/report/billing/getreport", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setReportdata(response.data.report_data)
                    setPopup_report(true)
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2 print-disable">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-file-chart-outline color-orange"></i> Site Billing Report</h4>
                                    <p className="mb-0">Query a biling and discount report.</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>
                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        <div className="d-block">
                            <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                            <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                setReportsite(e.target.value)
                            }} required>
                                {
                                    props.permitdata !== null ?
                                        props.permitdata.sitescope_arr.map((data, index) => (
                                            <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                        ))
                                        :
                                        null
                                }
                            </select>
                        </div>
                        <div style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Year</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={"year"}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                            <button className="btn btn-info btn-sm me-5" onClick={() => { api_get_permit_list() }}><i className="fas fa-search "></i> Seacrh</button>
                        </div>
                    </div>
                    <div className='print-disable'>
                        <h5 className='mt-3'>Query Result - {billdata.table_header}</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>#</th>
                                        <th>Month EN</th>
                                        <th>Month TH</th>
                                        <th>Contract Progress</th>
                                        <th>Last Update</th>
                                        <th style={{ width: "110px" }}>Select Report</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        billdata.permit?.map((data, index) => (
                                            <tr key={data.month_key}>
                                                <td> {index + 1}</td>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.month_en}</td>
                                                <td className='font-sarabun'> {data.month_th}</td>
                                                <td className='font-sarabun'>{data.sequence}</td>
                                                <td className='font-sarabun'>{data.last_update}</td>
                                                {
                                                    data.permit === true ?
                                                        <td>
                                                            <Link className="btn btn-sm btn-info btn-bordered" title="Edit"
                                                                onClick={() => { api_query_report(data.sitecode, data.month_key) }}><i className="fas fa-search"></i> Billing</Link>
                                                        </td>
                                                        :
                                                        <td><div style={{ height: "25px" }}>-</div></td>
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {popup_report ? <ReportBilling props={props} reportdata={reportdata} onClose={setPopup_report} /> : null}
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default ReportBill